import $ from 'jquery';
import TeaserBaseView from './TeaserBaseView';
import * as config from '../../home24/core/config';

export default TeaserBaseView.extend({
  events: {
    'mouseenter-not-touch .new-teaser-list a': 'onLinkMouseEnter',
    'touchend .new-teaser-list a': 'onLinkTouchEnd',
    'touchstart .content': 'onTouchStart',
    'touchend .content': 'onTouchEnd'
  },

  /**
   * @type {int}
   */
  fadeTime: config.getInt('marketing.teaser.hovering.intervals.fade'),

  /**
   * @type {Number}
   */
  hoverDelay: config.getInt('marketing.teaser.hovering.intervals.hover'),

  /**
   * @type {Number}
   */
  delayTimer: null,

  /**
   * @type {$}
   */
  $links: null,

  /**
   * @type {Number}
   */
  temporaryTarget: null,

  onLinkMouseEnter: function(event) {
    this.moveToTeaserByEvent(event);
  },

  onLinkTouchEnd: function(event) {
    var $target = $(event.currentTarget);

    this.blockTransition = true;

    /*
     * check if currently active is equal to touched, if yes then reload page, if not update image
     */
    if (!$target.hasClass('active')) {
      event.preventDefault();
      this.moveToTeaserByEvent(event);
    } else {
      $target.trigger('click');
    }
  },

  moveToTeaserByEvent: function(event) {
    this.fadeTo(
      $(event.currentTarget)
        .parent()
        .index()
    );
  },

  /**
   * @param {Number} target
   */
  fadeTo: function(target) {
    var $target = this.$teasers.eq(target);

    if (this.activeTeaser !== target && $target.length > 0) {
      if (this.delayTimer) {
        window.clearTimeout(this.delayTimer);
      }

      this.temporaryTarget = target;

      this.delayTimer = window.setTimeout(
        $.proxy(this.onLinkHoverTimeout, this),
        this.hoverDelay
      );
    }
  },

  /**
   * Sync current teaser to temporaryTarget
   */
  onLinkHoverTimeout: function() {
    var $target = this.$teasers.eq(this.temporaryTarget);

    this.activeTeaser = this.temporaryTarget;

    this.$teasers.stop(true, true);
    this.$teasers.fadeOut(this.fadeTime);

    if ($target.length === 1) {
      $target.fadeIn(this.fadeTime);
      this.markMenu();
    }
    this.postFadeTo();
  },

  /**
   * This pre-hook is executed before constructor logic
   */
  preInit: function() {
    this.$links = this.$('.new-teaser-list a');
  },

  postInit: function() {
    this.markMenu();
  },

  markMenu: function() {
    this.$links.removeClass('active');
    this.$links.eq(this.activeTeaser).addClass('active');
  },

  onTimeout: function() {
    if (!this.blockTransition) {
      this.fadeTo(this.getNextTeaser());
    }
  },

  toGlobalFallback: function() {
    this.$links.removeClass('active');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/TeaserListView.js
 **/